// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2Y0nK","header":"ReportDetails_header__1Rwkt","title":"ReportDetails_title__1MeLm","left":"ReportDetails_left__1GtoS"};